module.exports = __webpack_public_path__ + "static/media/refresh-icon.eb6243d7.gif";